<template>
  <div>
    <Head>
      <Title>{{ $t('pages.fixtures.meta.title', useTeamParams()) }}</Title>
      <Meta name="description" :content="$t('pages.fixtures.meta.description', useTeamParams())" />
      <!-- <Link rel="canonical" :href="useAbsolutePath()" /> -->
    </Head>
    <div class="space-y-4">
      <TeamNavFixtures />
      <PartialsGames :games="data?.games" />
      <TeamSeoText type="fixtures" class="mt-8" />
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'team'
})

const route = useRoute()
const team = useTeamStore()

const side = computed(() => route.query?.side || undefined)

const { data } = await useFetch(`/api/v1/teams/${team.slug}/games`, { 
  key: `team-fixtures-${team.slug}`,
  baseURL: useEnv('apiBase'),
  query: {
    fromDate: useDate().format('YYYY-MM-DD'),
    side: computed(() => side.value),
  }
})
</script>